<script>
import { apiSecond } from '@/boot/axios'

export default {
	name: 'CustomsInfo',
	data() {
		return {
			customsData: null,
			errorMessage: {
				status: null,
				text: null,
			},
			message: {
				status: null,
				text: null,
			},
			filters: {
				iin_bin: '',
			},
			options: {
				itemsPerPage: 15,
				page: 1,
			},
			headers: [
				{ text: 'ID', value: 'id' },
				{ text: this.$t('headers.type_operation'), value: 'TypeOperation' },
				{ text: this.$t('headers.customs_code'), value: 'CustomsCode' },
				{ text: this.$t('headers.date_product'), value: 'DateProduct' },
				{ text: this.$t('headers.country_origin'), value: 'CountryOrigin' },
				{ text: this.$t('headers.country_sender'), value: 'CountrySender' },
				{ text: this.$t('headers.country_destination'), value: 'CountryDestination' },
				{ text: this.$t('headers.code_state'), value: 'CodeState' },
				{ text: this.$t('headers.document_number'), value: 'DocumentNumber' },
				{ text: this.$t('headers.customs_number'), value: 'CustomsNumber' },
				{ text: this.$t('headers.name_state'), value: 'NameState' },
				{ text: this.$t('headers.iin_bin'), value: 'IinBin' },
				{ text: this.$t('headers.fio_receiver'), value: 'FioReceiver' },
				{ text: this.$t('headers.item_code'), value: 'ItemCode' },
				{ text: this.$t('headers.item_name'), value: 'ItemName' },
				{ text: this.$t('headers.item_weight'), value: 'ItemWeight' },
				{ text: this.$t('headers.item_price'), value: 'ItemPrice' },
				{ text: this.$t('headers.created_at'), value: 'created_at' },
			],
			total: 0,
		}
	},
	methods: {
		pagination(options) {
			this.fetchCustomsData(options.page, options.itemsPerPage)
		},

		async fetchCustomsData(page = 1, per_page = 15) {
			try {
				this.errorMessage = { status: null, text: null }

				// Get filters from route query
				const query = this.$route.query

				let url = 'v1/astana-ones/all'
				const urlParams = new URLSearchParams()

				// Add pagination parameters
				urlParams.append('page', page)
				urlParams.append('per_page', per_page)

				// Add filter parameters
				if (query.iin_bin) {
					urlParams.append('iin_bin', query.iin_bin)
				}

				// Build the final URL with query parameters
				if (urlParams.toString()) {
					url += '?' + urlParams.toString()
				}

				const response = await apiSecond.get(url)

				if (response.data) {
					this.customsData = response.data.data
					this.total = response.data.total
				}
			} catch (error) {
				console.error('Error fetching customs data:', error)
				this.errorMessage = {
					status: error.response?.status || 500,
					text: error.response?.data?.message || 'Ошибка загрузки данных',
				}
			}
		},

		async search() {
			this.options.page = 1
			this.pagination(this.options)
		},

		// Method to handle filter changes
		onFilterChange() {
			// Update route query parameters
			this.$router
				.push({
					query: {
						...this.$route.query,
						iin_bin: this.filters.iin_bin || undefined,
					},
				})
				.then(() => {
					this.search()
				})
		},
	},

	async mounted() {
		// Initialize filters from route query
		if (this.$route.query.iin_bin) {
			this.filters.iin_bin = this.$route.query.iin_bin
		}
		await this.fetchCustomsData(1, this.options.itemsPerPage)
	},
}
</script>

<template>
	<div class="wrap__content" v-bind:class="{ 'wrap__content--preloader': !customsData }">
		<v-preloader v-if="!customsData" :message="errorMessage"></v-preloader>

		<div class="container" v-if="customsData">
			<div class="row">
				<div class="col-xl-2 col-lg-3">
					<v-sidebar :active="['IntegrationPanel', 'CustomsInfo']"></v-sidebar>
				</div>
				<div class="col-xl-10 col-lg-9">
					<div class="content-wrapper">
						<div class="card__content">
							<div class="card__content-header">
								<div class="content__title">
									<div class="content__title--element">
										<div class="content__title--text">{{ $t('sidebar.customs_info') }}</div>
									</div>
								</div>
							</div>
							<div class="card__content--body">
								<div class="table__block--content">
									<div class="table__block--filter">
										<div class="form__line">
											<div class="form__line--left">
												<div class="form__line--title">{{ $t('headers.iin_bin') }}</div>
											</div>
											<div class="form__line--right">
												<div class="row">
													<div class="col-xl-5">
														<div class="form__line--input">
															<input
																v-model="filters.iin_bin"
																type="text"
																class="input-linck"
																name="iin_bin"
																:placeholder="$t('placeholder.search_by_iin_or_bin')"
																@keyup.enter="onFilterChange"
															/>
														</div>
													</div>
													<div class="col-xl-3">
														<button class="input-btn form__line--btn" @click="onFilterChange">
															{{ $t('button.find') }}
														</button>
													</div>
												</div>
											</div>
										</div>
									</div>

									<v-data-table
										:headers="headers"
										:items="customsData"
										:loading="false"
										:options.sync="options"
										:footer-props="{
											'items-per-page-options': [5, 10, 15, 20, 30, 50],
										}"
										:server-items-length="total"
										@update:options="pagination($event)"
									>
										<template #item.TypeOperation="{ item }">
											{{ item.TypeOperation }}
										</template>

										<template #item.CustomsCode="{ item }">
											{{ item.CustomsCode }}
										</template>

										<template #item.DateProduct="{ item }">
											{{ item.DateProduct | formatOnlyDate }}
										</template>

										<template #item.CountryOrigin="{ item }">
											{{ item.CountryOrigin }}
										</template>

										<template #item.CountrySender="{ item }">
											{{ item.CountrySender }}
										</template>

										<template #item.CountryDestination="{ item }">
											{{ item.CountryDestination }}
										</template>

										<template #item.CodeState="{ item }">
											{{ item.CodeState }}
										</template>

										<template #item.DocumentNumber="{ item }">
											{{ item.DocumentNumber }}
										</template>

										<template #item.CustomsNumber="{ item }">
											{{ item.CustomsNumber || '-' }}
										</template>

										<template #item.NameState="{ item }">
											{{ item.NameState }}
										</template>

										<template #item.IinBin="{ item }">
											{{ item.IinBin }}
										</template>

										<template #item.FioReceiver="{ item }">
											<div class="text-wrap" style="max-width: 200px; white-space: pre-line">
												{{ item.FioReceiver }}
											</div>
										</template>

										<template #item.ItemCode="{ item }">
											{{ item.ItemCode }}
										</template>

										<template #item.ItemName="{ item }">
											<div class="text-wrap" style="max-width: 200px; white-space: pre-line">
												{{ item.ItemName }}
											</div>
										</template>

										<template #item.ItemWeight="{ item }">
											{{ item.ItemWeight }}
										</template>

										<template #item.ItemPrice="{ item }">
											{{ item.ItemPrice }}
										</template>

										<template #item.created_at="{ item }">
											{{ item.created_at | formatDate }}
										</template>

										<v-alert slot="no-results" :value="true" color="error">
											{{ $t('system_message.search') }}
										</v-alert>
									</v-data-table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.text-wrap {
	word-wrap: break-word;
	overflow-wrap: break-word;
}
</style>
